import { DependencyList, useEffect } from "react";

import { window } from "../window";

/**
 * Custom React hook that debounces a side effect function.
 */

export const useDebounceEffect = (
  effect: () => void,
  dependency: DependencyList,
  timeout: number
): void => {
  useEffect(() => {
    const debounceTimoutId = window.setTimeout(() => {
      effect();
    }, timeout);

    return () => window.clearTimeout(debounceTimoutId);
  }, dependency);
};
